var TermsAndConditionsView = (function (BaseView) {

	var TermsAndConditionsView = BaseView.extend({

		events: {
			'click @termsCheckbox': 'onTermsCheckboxClick'
		},

		initialize: function (opts) {
			this.$el.addClass(opts.testClass && (opts.testClass + 'block') || 'test-check-block');
			this.$el.find('@termsCheckbox').addClass(opts.testClass && (opts.testClass + 'terms') || 'test-check-terms');

			this.listenTo(this.model, 'change:Value', _.bind(this._valueChanged, this));
			this.listenTo(this.model, 'change:Disabled', _.bind(this._toggle, this));

			this._valueChanged();
			this._toggle();
		},

		onTermsCheckboxClick: function () {
			this.model.set('Value', this.$el.find('@termsCheckbox')[0].checked);
		},

		_valueChanged: function () {
			this.$el.find('@termsCheckbox').prop('checked', this.model.get('Value'));
		},

		_toggle: function () {
			if (this.model.get('Disabled')) {
				this.$el.hide();
			} else {
				this.$el.show();
			}
		}
	});

	return TermsAndConditionsView;
})(BaseView);

